var _defs, _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 3200",
    width: 4000,
    height: 3200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vecteezy_c-letter-logo-icon-vector-illustration_-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1574.528,1492.537,0,1121.49,2387.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#624877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c82d71"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m2636.4 1293.5c-39.7-93.7-96.4-177.9-168.7-250.2-72.3-72.2-156.5-129-250.2-168.7-97.2-41-200.3-61.9-306.5-61.9-288.8 0-554 157.8-692 411.7-28.5 52.3-9.1 117.7 43.1 146.1 16.4 8.9 34 13.1 51.4 13.1 34 0 67-16.1 87.6-44.9q2.1-2.9 3.9-5.8 1.7-2.7 3.3-5.6c99.3-182.8 289.4-297 496.9-299.1q1.7 0 3.5 0h2.3q2.5 0 5.1 0c215.3 1.9 402.6 123.4 498.5 301.1 2.2 5.8 3.4 11.8 3.8 17.7 4.9 31-9.9 63-38.2 78.8-11.3 6.3-24.1 9.6-37 9.6-27.6 0-53.2-15-66.6-39.1-74.1-133.1-214.6-215.7-366.8-215.7-231.2 0-419.4 188.1-419.4 419.4 0 231.3 188.2 419.4 419.4 419.4 152.2 0 292.7-82.6 366.8-215.7 13.4-24.1 39-39.1 66.6-39.1 12.9 0 25.7 3.3 37 9.6 28.3 15.8 43.1 47.7 38.2 78.7-0.4 5.9-1.6 11.9-3.8 17.7-95.9 177.8-283.2 299.3-498.5 301.2q-2.6 0-5.1 0h-2.3q-1.8 0-3.5 0c-207.6-2.2-397.7-116.4-497-299.3q-1.6-2.9-3.3-5.6-1.8-2.9-3.8-5.7c-31.2-43.7-90.7-58.2-139-32-52.3 28.4-71.7 93.8-43.3 146.1 138 254.1 403.3 412 692.2 412 106.2 0 209.3-20.9 306.5-61.9 93.7-39.7 177.9-96.5 250.2-168.7 72.3-72.3 129-156.5 168.7-250.2 41-97.2 61.9-200.3 61.9-306.5 0-106.2-20.9-209.3-61.9-306.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e11fece2481f4f9f846cbc0bb0bfab07.svg";
export { ForwardRef as ReactComponent };